// @flow

import { routeTo } from 'redux-router-kit';
import { Account } from '@zapier/shared-entities';
import type { Dispatch, GetState } from 'app/common/types';

const TeamAccountActions = {
  saveAndRouteTo: (nextUrl: string, messages: {}, id: number) => (
    dispatch: Dispatch,
    getState: GetState
  ) => {
    return dispatch(Account.actions.saveEntity(messages, id)).then(() => {
      const account = Account.selectors.all.entity(id, getState());
      if (Account.selectors.isSuccess(account)) {
        dispatch(routeTo(nextUrl));
      }
    });
  },

  // Start a trial right away - now the action for all users
  startTrialImmediately: (id: number) => async (dispatch: Dispatch) => {
    const messages = {
      error: 'Couldn’t start trial, please try again.',
      shouldNotify: true,
    };

    dispatch(Account.actions.trialTeams(id));
    // Make sure auto upgrade is off, as it defaults to true
    dispatch(Account.actions.toggleTeamsAutoUpgrade(false, id));
    dispatch(TeamAccountActions.saveAndRouteTo('/app/home', messages, id));
  },
};

export default TeamAccountActions;
